import DepartamentDetailTabUser from '@/components/departament/DetailTabUser.vue'

const collaboratorRouter = (beforeEnter, name, singleName, basePath, tabs) => {
    return {
        beforeEnter: beforeEnter,
        name: `${singleName}DetalheAbaUsuarios`,
        path: `${basePath}/detalhe/:id/colaboradores`,
        meta: {
            requiresAuth: true,
            isEmployee: true,
            layout: 'default',
            basePath,
            singleName,
            add: {
                route: `${singleName}DetalheAbaUsuarioCadastrar`,
                label: `Cadastrar Colaborador`
            },
            editRoute: `${singleName}DetalheAbaUsuarioEditar`,
            tabs
        },
        component: DepartamentDetailTabUser
    }
}

export default collaboratorRouter
